<template>
  <div data-color-set>
    <a :href="imageSource" data-lightbox="" class="d-block m-0">
      <img
        class="artwork__image"
        :alt="artworkName"
        :src="imageSource"
        :data-magnify-src="imageSource"/>
    </a>
  </div>
</template>

<script>
  /* global $ */

  export default {
    name: 'ArtworkImage',
    props: {
      imageSource: {
        type: String,
        required: true,
      },
      artworkName: {
        type: String,
        required: true,
      },
    },
    methods: {
      openLightbox() {
        $('a').simpleLightbox({
          enableKeyboard: false,
          nav: false,
          showCounter: false,
          swipeTolerance: 1400,
          animationSlide: false,
        });
      },
      enableZoom() {
        $('a').on('shown.simplelightbox', () => {
          $('.sl-image').zoom({
            magnify: 2,
            on: 'click',
            onZoomIn() {
              $(this).addClass('zoomed');
            },
            onZoomOut() {
              $(this).removeClass('zoomed');
            },
          });
        });
      },
    },
    mounted() {
      this.openLightbox();
      this.enableZoom();
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/shared/components/artwork_image.vue?aa41dee0